import { Injectable, signal, WritableSignal } from '@angular/core';
import { TableColumns } from '../../../../ui-components/lib/table/table.model';

export type SortState = { key: string; value: 'asc' | 'desc' };

@Injectable()
export class TableSortService {
  private readonly _defaultSort: SortState = { key: '', value: 'asc' };
  readonly activeSort = signal<SortState>({ ...this._defaultSort });

  updateSort(
    column: TableColumns,
    currentPage: WritableSignal<number>,
    afterSort: () => void
  ): void {
    if (column.isSorted) {
      this.activeSort.set({
        key: column.sortKey || '',
        value: column.isSorted,
      });
    } else {
      this.activeSort.set({ ...this._defaultSort });
    }
    currentPage.set(1);
    afterSort();
  }

  reset(): void {
    this.activeSort.set({ ...this._defaultSort });
  }
}
